import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const municipalitiesManagement = createApi({
    reducerPath: "municipalitiesManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        municipalitiesList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/municipalities`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),

        addMunicipalities: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/municipalities`,
                method: "POST",
                body: body,
            }),
        }),

        viewMunicipalities: builder.mutation({
            query: (municipalityId) => ({
                url: `v1/${locale}/settings/municipalities/${municipalityId}`,
                method: "GET",
            }),
        }),

        updateMunicipalities: builder.mutation({
            query: ({body, municipalityId}) => ({
                url: `v1/${locale}/settings/municipalities/${municipalityId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteMunicipalities: builder.mutation({
            query: (municipalityId) => ({
                url: `v1/${locale}/settings/municipalities/${municipalityId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { 
    useMunicipalitiesListMutation,
    useDeleteMunicipalitiesMutation,
    useViewMunicipalitiesMutation,
    useAddMunicipalitiesMutation,
    useUpdateMunicipalitiesMutation 
} = municipalitiesManagement;
